import { defineComponent as Z, openBlock as o, createElementBlock as a, mergeProps as i, unref as e, renderSlot as p, createElementVNode as l, createCommentVNode as h } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, A = { key: 1 }, H = { key: 2 }, f = { key: 3 }, k = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconToggleRight"
}, b = /* @__PURE__ */ Z({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(m) {
    const r = m, { bind: s, weight: n } = u(r);
    return (d, t) => (o(), a("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      p(d.$slots, "default"),
      e(n) === "bold" ? (o(), a("g", g, t[0] || (t[0] = [
        l("path", { d: "M176,52H80a76,76,0,0,0,0,152h96a76,76,0,0,0,0-152Zm0,128H80A52,52,0,0,1,80,76h96a52,52,0,0,1,0,104Zm0-92a40,40,0,1,0,40,40A40,40,0,0,0,176,88Zm0,56a16,16,0,1,1,16-16A16,16,0,0,1,176,144Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (o(), a("g", A, t[1] || (t[1] = [
        l("path", {
          d: "M208,128a32,32,0,1,1-32-32A32,32,0,0,1,208,128Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,128H80A56,56,0,0,1,80,72h96a56,56,0,0,1,0,112Zm0-96a40,40,0,1,0,40,40A40,40,0,0,0,176,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,176,152Z" }, null, -1)
      ]))) : e(n) === "fill" ? (o(), a("g", H, t[2] || (t[2] = [
        l("path", { d: "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,176,168Z" }, null, -1)
      ]))) : e(n) === "light" ? (o(), a("g", f, t[3] || (t[3] = [
        l("path", { d: "M176,58H80a70,70,0,0,0,0,140h96a70,70,0,0,0,0-140Zm0,128H80A58,58,0,0,1,80,70h96a58,58,0,0,1,0,116Zm0-96a38,38,0,1,0,38,38A38,38,0,0,0,176,90Zm0,64a26,26,0,1,1,26-26A26,26,0,0,1,176,154Z" }, null, -1)
      ]))) : e(n) === "regular" ? (o(), a("g", k, t[4] || (t[4] = [
        l("path", { d: "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,128H80A56,56,0,0,1,80,72h96a56,56,0,0,1,0,112Zm0-96a40,40,0,1,0,40,40A40,40,0,0,0,176,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,176,152Z" }, null, -1)
      ]))) : e(n) === "thin" ? (o(), a("g", w, t[5] || (t[5] = [
        l("path", { d: "M176,60H80a68,68,0,0,0,0,136h96a68,68,0,0,0,0-136Zm0,128H80A60,60,0,0,1,80,68h96a60,60,0,0,1,0,120Zm0-96a36,36,0,1,0,36,36A36,36,0,0,0,176,92Zm0,64a28,28,0,1,1,28-28A28,28,0,0,1,176,156Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  b as default
};
